module.exports = __webpack_public_path__ + "img/home.90ce5885.png";